import React, { useEffect, useState } from "react";
import {
  Modal,
  Card,
  Row,
  Col,
  Badge,
  Table,
  Button,
  Form,
} from "react-bootstrap";
import API from "../../api/api";
import { toast } from "react-toastify";

export default function OrdersModal({
  show,
  handleClose,
  payload = {},
  setPayload,
  getAllData,
  user = {}, // user lgged in
}) {
  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  console.log(payload);
  let orderId = null;

  if (payload) {
    orderId = payload._id;
  }
  // const { orderId } = payload._id;

  useEffect(() => {
    if (!orderId) return;

    const fetchOrder = async () => {
      try {
        const res = await API.get(`/api/checkout/${orderId}`, {
          withCredentials: true,
        });
        if (res.data.success) {
          setOrder(res.data.order);
          setStatus(res.data.order.status);
          setPaymentStatus(res.data.order.paymentStatus);
        }
      } catch (err) {
        console.error("Error fetching order:", err);
      }
    };

    if (show) fetchOrder();
  }, [orderId, show]);

  const handleUpdate = async () => {
    try {
      const res = await API.patch(
        `/api/checkout/${orderId}/status`,
        { status, paymentStatus },
        { withCredentials: true }
      );
      if (res.data.success) {
        console.log(res.data);

        setOrder(res.data.order);
        toast.success("Operation Successful");
        getAllData();
        handleClose();
        setPayload({});
      }
    } catch (err) {
      toast.success("Something went wrong!");

      console.error("Error updating order:", err);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Order Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {payload.loadType === "View Order" && (
          <div>
            {!order ? (
              <p>Loading order details...</p>
            ) : (
              <>
                {/* Action Bar */}
                {user?.role === "admin" && (
                  <Card className="shadow-sm mb-4">
                    <Card.Body>
                      <Row style={{ display: "flex", alignItems: "center" }}>
                        <Col md={5} className="mb-3">
                          <Form.Group>
                            <Form.Label>Update Status</Form.Label>
                            <Form.Select
                              value={status}
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              <option value="Processing">Processing</option>
                              <option value="Shipped">Shipped</option>
                              <option value="Delivered">Delivered</option>
                              <option value="Cancelled">Cancelled</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col md={5} className="mb-3">
                          <Form.Group>
                            <Form.Label>Payment Status</Form.Label>
                            <Form.Select
                              value={paymentStatus}
                              onChange={(e) => setPaymentStatus(e.target.value)}
                            >
                              <option value="Unpaid">Unpaid</option>
                              <option value="Pending">Pending</option>
                              <option value="Paid">Paid</option>
                              <option value="Failed">Failed</option>
                              <option value="Refunded">Refunded</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col md={2}>
                          <Button
                            variant="primary"
                            onClick={handleUpdate}
                            className="mt-2 w-100"
                          >
                            Update
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}

                {/* Order Summary */}
                <Card className="shadow-sm mb-3">
                  <Card.Body>
                    <h5>Order #{order.orderNumber}</h5>
                    <p>
                      <strong>Status:</strong>{" "}
                      <Badge
                        bg={
                          order.status === "Processing"
                            ? "warning"
                            : order.status === "Shipped"
                            ? "info"
                            : order.status === "Delivered"
                            ? "success"
                            : "danger"
                        }
                      >
                        {order.status}
                      </Badge>
                    </p>
                    <p>
                      <strong>Payment:</strong>{" "}
                      <Badge
                        bg={
                          order.paymentStatus === "Unpaid"
                            ? "secondary"
                            : order.paymentStatus === "Pending"
                            ? "warning"
                            : order.paymentStatus === "Paid"
                            ? "success"
                            : "danger"
                        }
                      >
                        {order.paymentStatus}
                      </Badge>{" "}
                      ({order.paymentMethod})
                    </p>
                    <h6>Total: Rs. {order.totalAmount}</h6>
                  </Card.Body>
                </Card>

                {/* Customer Info */}
                <Card className="shadow-sm mb-3">
                  <Card.Header>Customer Information</Card.Header>
                  <Card.Body>
                    <p>
                      <strong>Name:</strong> {order.user?.first_name}{" "}
                      {order.user?.last_name}
                    </p>
                    <p>
                      <strong>Email:</strong> {order.user?.email}
                    </p>
                    <p>
                      <strong>Phone:</strong> {order.user?.phone}
                    </p>
                  </Card.Body>
                </Card>

                {/* Distributor Info */}
                <Card className="shadow-sm mb-3">
                  <Card.Header>Assigned Distributor</Card.Header>
                  <Card.Body>
                    <p>
                      <strong>Name:</strong>{" "}
                      {order.assigned_distributor?.first_name}{" "}
                      {order.assigned_distributor?.last_name}
                    </p>
                    <p>
                      <strong>Email:</strong>{" "}
                      {order.assigned_distributor?.email}
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      {order.assigned_distributor?.phone}
                    </p>
                    <p>
                      <strong>Referral Code:</strong> {order.referral_code_used}
                    </p>
                  </Card.Body>
                </Card>

                {/* Shipping Info */}
                <Card className="shadow-sm mb-3">
                  <Card.Header>Shipping Address</Card.Header>
                  <Card.Body>
                    <p>{order.shippingAddress?.address}</p>
                    <p>
                      {order.shippingAddress?.city},{" "}
                      {order.shippingAddress?.postal}
                    </p>
                    <p>{order.shippingAddress?.country}</p>
                    {order.shippingAddress?.apartment && (
                      <p>Apt: {order.shippingAddress.apartment}</p>
                    )}
                  </Card.Body>
                </Card>

                {/* Products */}
                <Card className="shadow-sm">
                  <Card.Header>Products</Card.Header>
                  <Card.Body>
                    <Table responsive bordered hover>
                      <thead className="table-light">
                        <tr className="text-center">
                          <th>#</th>
                          <th style={{ minWidth: "150px" }}>Product</th>
                          <th style={{ minWidth: "100px" }}>Price (Rs.)</th>
                          <th style={{ minWidth: "100px" }}>Quantity</th>
                          <th style={{ minWidth: "100px" }}>Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {order.items.map((item, i) => (
                          <tr key={item._id} className="text-center">
                            <td>{i + 1}</td>
                            <td>
                              {item.product?.image && (
                                <img
                                  src={item.product.image}
                                  alt={item.product.title}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    marginRight: "8px",
                                    borderRadius: "4px",
                                  }}
                                />
                              )}
                              {item.product?.title || item.product}
                            </td>
                            <td>{item.price}</td>
                            <td>{item.quantity}</td>
                            <td>{item.quantity * item.price}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
